import { createFilterSlice } from './filterSlice';

const STORAGE_KEY = 'insightDebtorsFilters';
const defaultDebtorsFilters = {
	effectiveFromDate: null,
	effectiveToDate: null,
	transactionFilter: null,
	asAtDate: null,
	fundingStatus: [],
	ownerIds: [],
	outstandingDate: null,
};

export const insightDebtorsPrefsSlice = createFilterSlice({
	sliceName: 'debtorsFilterPrefs',
	storageKey: STORAGE_KEY,
	defaultFilters: defaultDebtorsFilters,
});

export const {
	setEffectiveFromDate,
	setEffectiveToDate,
	setTransactionFilter,
	setAsAtDate,
	setFundingStatus,
	setOwnerIds,
	setOutstandingDate,
	resetFilters,
} = insightDebtorsPrefsSlice.actions;

export default insightDebtorsPrefsSlice.reducer;
